import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from "@chakra-ui/react";
import { Spinner } from "components/Spinner/Spinner";
import { useFirebase } from "hooks/useFirebase";
import { MailLog } from "hooks/useMails";

// Shows the exact HTML stored by functions/src/Mail.ts in mailBodies/{mail id}
export function MailPreview({ mail, onClose }: { mail?: MailLog; onClose: () => void }) {
  const { t } = useTranslation();
  const { db } = useFirebase();
  const [html, setHtml] = useState<string | null>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!mail) return;
    let current = true;
    setHtml(undefined);
    setError(false);
    db.collection("mailBodies")
      .doc(mail.id)
      .get()
      .then((doc: any) => current && setHtml(doc.exists ? doc.data().html : null))
      .catch((e: unknown) => {
        console.error("MailPreview", e);
        if (current) setError(true);
      });
    return () => {
      current = false;
    };
  }, [db, mail]);

  return (
    <Modal isOpen={Boolean(mail)} onClose={onClose} size="4xl">
      <ModalOverlay bg="blackAlpha.400" />
      <ModalContent borderRadius={16}>
        <ModalHeader fontSize={18} pr="50px">
          {mail?.subject}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="24px">
          {error ? (
            <Text color="red.600">{t("common:E-mail content could not be loaded")}</Text>
          ) : html === undefined ? (
            <Spinner />
          ) : html === null ? (
            <Text>{t("common:No stored content for this e-mail")}</Text>
          ) : (
            // Empty sandbox: no scripts, forms, popups or navigation of the app; mail styles stay inside the frame
            <iframe
              sandbox=""
              srcDoc={html}
              style={{ border: "1px solid #e2e8f0", borderRadius: 8, height: "70vh", width: "100%" }}
              title={mail?.subject}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
